
import { Box, Container, Grid, Typography, alpha } from '@mui/material';
import {
  Hub,
  Savings,
  AccessTime,
  Apartment,
  Security,
  VideoLibrary,
  Devices,
  Campaign,
} from '@mui/icons-material';
import { useTenantConfig } from '../hooks/useTenant';




const VideoConferenceAdvantages = () => {

  const {tenantName} = useTenantConfig();

  const advantages = [
  {
    title: 'Tek Platform Üzerinden Yönetim',
    desc: `Toplantılarınızı farklı uygulamalara ihtiyaç duymadan doğrudan ${tenantName} yönetim paneli üzerinden planlayabilir ve yönetebilirsiniz.`,
    icon: Hub,
    color: '#ec4899'
  },
  {
    title: 'Ek Yazılım veya Lisans Gerektirmez',
    desc: `Üçüncü parti video konferans araçlarına ihtiyaç kalmadan tüm toplantılarınızı kendi sisteminiz üzerinden gerçekleştirebilirsiniz.`,
    icon: Savings,
    color: '#f97316'
  },
  {
    title: 'Zaman ve Maliyet Tasarrufu',
    desc: 'Fiziksel toplantı organizasyonları için gereken mekân ve ulaşım maliyetlerini ortadan kaldırır.',
    icon: AccessTime,
    color: '#10b981'
  },
  {
    title: 'Şubeler Arası Kolay İletişim',
    desc: 'Farklı şehirlerde bulunan şubeler aynı toplantıda bir araya gelerek hızlı ve etkili iletişim kurabilir.',
    icon: Apartment,
    color: '#0891b2'
  },
  {
    title: 'Güvenli Kurum İçi Toplantılar',
    desc: 'Parola korumalı toplantılar sayesinde yalnızca davet edilen kişiler toplantıya katılabilir.',
    icon: Security,
    color: '#8b5cf6'
  },
  {
    title: 'Toplantı Kayıt ve Arşivleme',
    desc: 'Gerçekleştirilen toplantılar kayıt altına alınabilir ve daha sonra tekrar izlenmek üzere arşivlenebilir.',
    icon: VideoLibrary,
    color: '#6366f1'
  },
  {
    title: 'Her Cihazdan Katılım',
    desc: 'Bilgisayar, tablet ve mobil cihazlardan kolayca toplantılara katılım sağlanabilir.',
    icon: Devices,
    color: '#eab308'
  },
  {
    title: 'Davet ve Hatırlatma Bildirimleri',
    desc: 'SMS, e-posta ve sistem bildirimleri ile toplantı davetleri gönderilebilir ve katılım oranı artırılabilir.',
    icon: Campaign,
    color: '#f43f5e'
  }
];


  return (
    <Box sx={{ py: { xs: 8, md: 12 },bgcolor: '#ffffff'}}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  mb: 3,
                  color: '#0f172a',
                  fontSize: { xs: '1.9rem', md: '2.4rem' }
                }}
          >
            Dernekler İçin Avantajları
          </Typography>
          <Typography
               sx={{
                  fontSize: '1.05rem',
                  color: '#475569',
                  lineHeight: 1.8,
                  mb: 4,
                }}
          >
            {tenantName} Video Konferans sistemi sayesinde dernekler toplantılarını daha hızlı,
            güvenli ve verimli bir şekilde gerçekleştirebilir.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {advantages.map((item, index) => {
            const Icon = item.icon;
            return (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box
                  sx={{
                    p: 3.5,
                    height: '100%',
                    borderRadius: 4,
                    border: '1px solid #e5e7eb',
                    background: 'white',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: `0 8px 32px ${alpha(item.color, 0.12)}`,
                      borderColor: alpha(item.color, 0.3),
                      transform: 'translateY(-4px)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: `linear-gradient(135deg, ${alpha(item.color, 0.1)} 0%, ${alpha(
                        item.color,
                        0.05
                      )} 100%)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto',
                      mb: 2.5,
                      color: item.color,
                      '& svg': { fontSize: 32 },
                    }}
                  >
                    <Icon />
                  </Box>

                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '1rem',
                      mb: 1.5,
                      color: '#1e293b',
                      lineHeight: 1.3,
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: '#64748b',
                      fontSize: '0.875rem',
                      lineHeight: 1.6,
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default VideoConferenceAdvantages;